import { Linking } from 'react-native';

/**
 * True for an address a recipe may send the cook to: http or https.
 *
 * A recipe's `sourceUrl` and `videoUrl` come from imports and from the editor,
 * and a household partner can set them. React Native Web's `Linking.openURL`
 * hands any scheme to `window.open`, so a stored `javascript:` link ran in the
 * app's own origin for whoever tapped « Source » (security review, 2026-11-02).
 */
export function isWebUrl(url: unknown): url is string {
  if (typeof url !== 'string') return false;
  try {
    const { protocol } = new URL(url.trim());
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}

/** Open a recipe's link, or do nothing when it is not a web address. Resolves to whether it opened. */
export async function openExternalUrl(url: unknown): Promise<boolean> {
  if (!isWebUrl(url)) return false;
  await Linking.openURL(url.trim());
  return true;
}
